import script from "./ExpandButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpandButton.vue?vue&type=script&lang=ts&setup=true"

import "./ExpandButton.vue?vue&type=style&index=0&id=6f19850c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f19850c"]])

export default __exports__